import React from 'react'
import PropTypes from 'prop-types'
import ModalFooter from 'components/ModalFooter'
import ModalHeader from 'components/ModalHeader'
import ModalIntro from 'components/ModalIntro'
import ModalOutro from 'components/ModalOutro'
import { StyledModal } from './component.styles'
import AddGoals from './AddGoals'

const GoalsModal = ({
  additionalGoalCount,
  currentStep,
  flowLabel,
  handleCancel,
  handleChangeGoalCount,
  handleClose,
  handleCancelButtonClick,
  handleNextButtonClick,
  isComplete,
  modals,
  values,
  errors,
  touched,
  handleChange,
  hasApiError,
  goBack,
  isSubmitting,
  isValid,
}) => {
  const [introData, addGoalsData, finishData] = modals || []
  const currentModal = modals?.[currentStep] || {}
  const { cancelLabel, helpCopy, nextLabel } = currentModal
  const shouldSave = currentStep === 1

  return (
    !!modals && (
      <StyledModal
        dataTestId="goals-modal"
        isModalOpen
        modalClose={() => handleClose}
      >
        <ModalHeader
          flowLabel={flowLabel}
          handleCancel={handleCancel}
          handleClose={handleClose}
          handleGoBack={goBack}
          showBackButton={currentStep !== 0}
        />

        {currentStep === 0 && <ModalIntro modalData={introData} />}
        {currentStep === 1 && (
          <AddGoals
            additionalGoalCount={additionalGoalCount}
            errors={errors}
            handleChange={handleChange}
            handleChangeGoalCount={handleChangeGoalCount}
            hasApiError={hasApiError}
            isValid={isValid}
            modalData={addGoalsData}
            touched={touched}
            values={values}
          />
        )}
        {currentStep === 2 && (
          <ModalOutro buttonOnClick={handleClose} modalData={finishData} />
        )}
        {currentStep !== 2 && (
          <ModalFooter
            cancelButtonText={cancelLabel}
            handleCancelButtonClick={() =>
              handleCancelButtonClick(shouldSave, false)
            }
            handleNextButtonClick={() =>
              handleNextButtonClick(shouldSave, true)
            }
            hasApiError={hasApiError}
            helpCopy={helpCopy}
            isSubmitting={isSubmitting}
            isValid={true}
            modalName="goals"
            nextButtonText={nextLabel}
            showCancelButton={currentStep === 1 && !isComplete}
          />
        )}
      </StyledModal>
    )
  )
}

GoalsModal.propTypes = {
  additionalGoalCount: PropTypes.number,
  currentStep: PropTypes.number,
  errors: PropTypes.object,
  flowLabel: PropTypes.string,
  goBack: PropTypes.func,
  handleCancel: PropTypes.func,
  handleCancelButtonClick: PropTypes.func,
  handleChange: PropTypes.func,
  handleChangeGoalCount: PropTypes.func,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  isComplete: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValid: PropTypes.bool,
  modals: PropTypes.array,
  touched: PropTypes.object,
  values: PropTypes.object,
}

export default GoalsModal
